import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  startVisitor,
  emailAddressVisitor,
  provincesVisitor,
  datePicker,
  country,
  confirmVisitor,
  thanksVisitor,
} from './canada-visitor-steps'

export const canadaVisitorScenarioA: Scenario = {
  id: 'canada-visitor-a',
  initialStep: Steps.START_VISITOR,
  type: ScenarioType.CANADA_VISITOR,
  version: '1',
  milestones: [
    startVisitor.id,
    emailAddressVisitor.id,
    provincesVisitor.id,
    datePicker.id,
    country.id,
    confirmVisitor.id,
    thanksVisitor.id,
  ],
  steps: [startVisitor, emailAddressVisitor, provincesVisitor, datePicker, country, confirmVisitor, thanksVisitor],
  weight: 1,
}
